import { render } from "./InfoCardsSubsection.vue?vue&type=template&id=8cf8cb2c&ts=true"
import script from "./InfoCardsSubsection.vue?vue&type=script&lang=ts"
export * from "./InfoCardsSubsection.vue?vue&type=script&lang=ts"

import "./InfoCardsSubsection.vue?vue&type=style&index=0&id=8cf8cb2c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__